import { post as $post } from './core/fetch';


export const save_cost = (cost) => $post('/save-cost', cost);
export const material_price = (req) => $post('/material-price', req);
export const cost_report = (req) => $post('/cost-report', req);
